import { c as _c } from "react/compiler-runtime";
import React from "react";
import { ApiWave } from "@/generated/models/ApiWave";
import Link from "next/link";
interface WaveRatingRepProps {
  readonly wave: ApiWave;
}
export default function WaveRatingRep(t0) {
  const $ = _c(13);
  const {
    wave
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="tw-font-medium tw-text-iron-400">Category:</span>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== wave.voting.credit_category) {
    t2 = <div className="tw-flex tw-flex-col">{t1}<span className="tw-font-medium tw-text-iron-50">{wave.voting.credit_category}</span></div>;
    $[1] = wave.voting.credit_category;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="tw-font-medium tw-text-iron-400">Creditor:</span>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  let t5;
  if ($[4] !== wave.voting.creditor) {
    t4 = wave.voting.creditor?.pfp ? <img className="tw-flex-shrink-0 tw-h-6 tw-w-6 tw-rounded-md tw-bg-iron-800" src={wave.voting.creditor.pfp} alt={wave.voting.creditor.handle ?? ""} /> : <div className="tw-flex-shrink-0 tw-h-6 tw-w-6 tw-rounded-md tw-bg-iron-800" />;
    t5 = wave.voting.creditor?.handle && <Link href={`/${wave.voting.creditor.handle}`} className="tw-no-underline tw-font-medium tw-text-iron-50 hover:tw-text-iron-300 tw-transition-colors">{wave.voting.creditor.handle}</Link>;
    $[4] = wave.voting.creditor;
    $[5] = t4;
    $[6] = t5;
  } else {
    t4 = $[5];
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t4 || $[8] !== t5) {
    t6 = <div className="tw-flex tw-flex-col tw-gap-y-1">{t3}<div className="tw-flex tw-items-center tw-gap-x-2">{t4}{t5}</div></div>;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t2 || $[11] !== t6) {
    t7 = <div className="tw-bg-iron-800 tw-rounded-xl tw-flex tw-flex-col tw-gap-y-3 tw-px-4 tw-py-3">{t2}{t6}</div>;
    $[10] = t2;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
}